import { render, staticRenderFns } from "./invoiceTab.vue?vue&type=template&id=cdda7500&"
import script from "./invoiceTab.vue?vue&type=script&lang=js&"
export * from "./invoiceTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports